<template>
  <div class="tag" 
    :class="[
      {
        active: active,
        selected: selected
      }
    ]"
  >
    <div class="label">
      {{label}}
    </div>
    <div class="extra">
      {{extra}}
    </div>
  </div>
</template>


<script>

export default {
  props: {
    selected: Boolean,
    label: [String, Number],
    extra: [String, Number],
    active: [Boolean]
  }
}

</script>

<style lang="scss" scoped>

.tag {
  cursor: pointer;
  display: inline-flex;
  padding: 0 16px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #BDBDBD;
  background-color: white;
  border-radius: 45px;
  user-select: none;
  &:hover {
    background-color: var(--gray-200);
  }
  &:active {
    background-color: var(--gray-300);
  }
  &.active {
    background-color: var(--gray-200);
  }
  &.selected {
    background-color: var(--primary-100);
    border-color: var(--primary-500);
  }
  @media screen and (max-width: 600px) {
    height: 30px;
  }
}

.label {
  color: var(--gray-900);
  font-size: var(--typ-body3);
  font-weight: 700;
  @media screen and (max-width: 600px) {
    font-size: var(--typ-body5);
  }
}

.extra {
  color: var(--primary-500);
  font-size: var(--typ-body2);
  font-weight: 700;
  margin-left: 16px;
  @media screen and (max-width: 600px) {
    font-size: var(--typ-body4);
  }
}

</style>